// extracted by mini-css-extract-plugin
module.exports = {"contentTirarFirmes":"tiraFirmes_contentTirarFirmes__fl5mO"};